import { render } from "./KdsManagement.vue?vue&type=template&id=a1ffdf6c&scoped=true"
import script from "./KdsManagement.vue?vue&type=script&lang=js"
export * from "./KdsManagement.vue?vue&type=script&lang=js"

import "./KdsManagement.vue?vue&type=style&index=0&id=a1ffdf6c&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1ffdf6c"]])

export default __exports__